import {CircularProgress, Paper, TableContainer, TableRow, TableCell, Table, TableBody, TableHead, Dialog, Grid, AppBar, Toolbar, Typography, IconButton} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {TAB_TIME, TAB_MONTH_MATRIX} from './StatsCommon.js';
import {getSpecName, getShortSpecName} from '../Trans.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import StatsFilter from './StatsFilter.js';
import {DarkenColor} from '../Util.js';
import {COMM_OK} from '../WsR2.js';

const MissingDialog = ((props) => {
	const {t} = useTranslation('obs');

	if (!props.missingList)
		return null;
	
	function copyToClipboard() {
		let cpText = '';

		props.missingList.forEach((item, i) => {
			if (cpText.length)
				cpText += ', ';

			cpText += item.spec;
		});

		navigator.clipboard.writeText(cpText);
	}

	return (
        	<Dialog onClose={props.handleClose} aria-labelledby="simple-dialog-title" open={props.missingList ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<Grid size={{xs: 12}} align={'center'}>
					<AppBar position="sticky">
						<Toolbar variant="dense">
							<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('stats.month_missing')}</Typography>
							
							<IconButton edge="start" color="inherit" onClick={copyToClipboard} aria-label="close">
								<ContentCopyIcon />
							</IconButton>

							<IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
				</Grid>
				<TableContainer component={Paper} elevation={0} sx={{height: 'max-content'}}>
					<Table size='small' sx={{height: 'max-content'}}>
						<TableHead>
							<TableRow padding='checkbox'>
								<TableCell align='left'>{
									t('main.species')}
								</TableCell>
								<TableCell align='right'>#</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{props.missingList.map((item, pos) => {
								return (
									<TableRow padding='checkbox' key={pos}>
										<TableCell align='left'>{item.spec}</TableCell>
										<TableCell align='right'>{item.hits}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Dialog>
	);
});

const MonthDialog = ((props) => {
// 	const {t} = useTranslation('obs');

	if (!props.spec)
		return null;

	const key = parseInt(Object.keys(props.spec)[0], 10);

	const months = (Object.values(props.spec)[0]).months.toSorted((a, b) => {
		if (a.year !== b.year)
			return b.year - a.year;
		
		return b.month - a.month;
	});

	return (
        	<Dialog onClose={props.handleClose} aria-labelledby="simple-dialog-title" open={props.spec ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<Grid size={{xs: 12}} align={'center'}>
					<AppBar position="sticky">
						<Toolbar variant="dense">
							<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{props.getSpecName(key)}</Typography>
							<IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
				</Grid>
				<TableContainer component={Paper} elevation={0} sx={{height: 'max-content'}}>
					<Table size='small' sx={{height: 'max-content'}}>
						<TableBody>
							{months.map((item, pos) => {
								if (item.year && item.month) {
									return (
										<TableRow padding='checkbox' key={pos}>
											<TableCell align='left' sx={{width:20}}>{(Object.values(props.spec)[0]).hits - pos + '.'}</TableCell>
											<TableCell align='left'>{item.year + '/' + item.month}</TableCell>
										</TableRow>
									);
								} else {
									return null;
								}
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Dialog>
	);
});

const StatsMonthMatrix = observer((props) => {
	const [missingList, setMissingList] = useState(null);
	const [monthList, setMonthList] = useState(null);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let m_pts;

	function monthMissingRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('monthMissingRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('monthMissingRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH_MATRIX)
			return;

// 		console.log('monthMissingRxWs', msg.data);

		gStorage.stats.setObsList(msg.data.spec_rep.sort((a, b) => {
			const _a = Object.values(a)[0];
			const _b = Object.values(b)[0];

			if (_a.hits !== _b.hits)
				return _b.hits - _a.hits;

			if (_a.year !== _b.year)
				return _a.year - _b.year;

			return _a.month - _b.month;
		}));
	}

	function loadMonthMissing() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'month',
			op: 'spec_rep',
			data: {
				country: gStorage.stats.country.id
			}
		}
// 		console.log('loadMonthMissingtats', msg);
		gStorage.conn.ws.send(msg, monthMissingRxWs);
	}

	function monthMissingGetSpecName(id) {
		const name = gStorage.lists.speclist.list.find(option => option.id === id);
		return getSpecName(name, gStorage.conn.user);
	}

	function monthMissingGetShortSpecName(id) {
		const name = gStorage.lists.speclist.list.find(option => option.id === id);
		return getShortSpecName(name, gStorage.conn.user);
	}

	function showMissing(month, ev) {
		let ma = [];

		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0)
			return;

		gStorage.stats.obsList.forEach((item, pos) => {
			const a_val = Object.values(item)[0];

			// console.log('pos', pos, Object.keys(item)[0]); 

			if (!a_val.months[month].num && a_val.hits > 0 && a_val.hits < 12) {
				ma.push({spec: monthMissingGetShortSpecName(parseInt(Object.keys(item)[0], 10)), hits: a_val.hits});
			}
		});

		ma.sort((a, b) => {
			if (b.hits !== a.hits)
				return b.hits - a.hits;

			return a.spec.localeCompare(b.spec, 'fi');
		});

		setMissingList(ma);
	}

	function listClose() {
		setMissingList(null);
	}
	
	function showSpecMonths(spec) {
		setMonthList(spec);
	}

	function monthClose() {
		setMonthList(null);
	}
	
	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH_MATRIX)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online)
		loadMonthMissing();

	const currMonth = new Date().getMonth();

	if (!gStorage.stats.obsList) {
		return (
			<>
				<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
					<CircularProgress sx={{mt: 10}} />
				</Grid>
			</>
		);
	}

	m_pts = 0;

	return (
		<>
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<StatsFilter 
						loc = {{country: {
								value: gStorage.stats.country,
								style: {width: 200}
							}}
						}
					/>
				</Grid>
			</Grid>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow padding='checkbox'>
							<TableCell align='center' style={{width: 16}}>#</TableCell>
							<TableCell align='left'>{t('main.species')}</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 0)}>1</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 1)}>2</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 2)}>3</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 3)}>4</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 4)}>5</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 5)}>6</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 6)}>7</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 7)}>8</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 8)}>9</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 9)}>10</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 10)}>11</TableCell>
							<TableCell align='center' style={{width: 16, cursor: 'pointer'}} onClick={showMissing.bind(this, 11)}>12</TableCell>
							<TableCell align='left'>{t('common.sum_short')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{gStorage.stats.obsList && gStorage.stats.obsList.map((item, pos) => {
							const n_hits = Object.values(item)[0].hits;
							let bg = '#ffffff';

							if (n_hits === 12) {
								bg = '#cbffe2';
							} else {
								if (pos % 2) {
									bg = '#f0f0f0';
								}
							}

							m_pts += n_hits;

							return (
								<TableRow key={pos} padding='checkbox' style={{backgroundColor: bg}}>
									<TableCell align='center' style={{width: 16}}>{pos + 1}</TableCell>
									<TableCell align='left' sx={{cursor: 'pointer'}} onClick={showSpecMonths.bind(this, item)}>{monthMissingGetSpecName(parseInt(Object.keys(item)[0], 10))}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 0 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[0].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 1 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[1].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 2 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[2].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 3 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[3].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 4 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[4].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 5 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[5].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 6 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[6].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 7 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[7].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 8 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[8].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 9 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[9].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 10 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[10].num ? '✓' : ''}</TableCell>
									<TableCell align='center' style={{width: 16, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightGray', backgroundColor: currMonth === 11 ? DarkenColor(bg, 8) : bg}}>{(Object.values(item)[0]).months[11].num ? '✓' : ''}</TableCell>
									<TableCell align='left'>{n_hits}</TableCell>
								</TableRow>);
						})}

						<TableRow key={gStorage.stats.obsList.length + 1} padding='checkbox'>
							<TableCell colSpan={14}>&nbsp;</TableCell>
							<TableCell align='left' style={{fontWeight: 'bold'}}>{m_pts}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>

			<MissingDialog missingList={missingList} handleClose={listClose} getSpecName={monthMissingGetSpecName}/>
			<MonthDialog spec={monthList} handleClose={monthClose} getSpecName={monthMissingGetSpecName}/>
		</>
	);
});

export default StatsMonthMatrix;
